import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  ecatDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-statement-document.controller';
import directive from './attach-statement-document.directive';


export default angular.module('app.components.advisory.eact.attachStatementDocument', [
  alerts,
  ecatDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('ecatAttachStatementDocument', directive)
  .controller('AttachStatementDocumentController', controller)
  .name;

console.log('app.components.advisory.ecat.attachStatementDocument created');
